<div style="padding:10px 0">
  <div class="min-heightcontainer">
    <div class="margin0">
      <div class="row">
        <div class="col-xs-8">
        </div>
        <div class="col-xs-4 text-right">
          <button class="right-btn btn  btn-circle btn-green adduserbtn" *ngIf="IsInitialLoad == 1 && canEdit" href="#" placement="left" tooltip="Edit Criteria" (click)="editCriteria();" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
        </div>
      </div>
      <div class="row" *ngIf="IsInitialLoad!=1">
        <div class="col-lg-4 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Asking Price</label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="margin-bottom-20 row">
                  <div class="resp-col">
                    <div class="textbox-with-btn-left">
                      <input type="text" [attr.disabled]="IsInitialLoad == 1 ? 'true' : null" inputmode="numeric" class="form-control interestcriteriadisable" placeholder="- Min -" maxlength="18" dropSpecialCharacters="false" mask="separator.10.0" thousandSeparator=","
                             [(ngModel)]="interestcriteriaInputModel.askingpricemin" (change)="onlyDecimal($event);" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)">
                      <span class="leftlabel">$</span>
                    </div>
                    <span class="minusspan">-</span>
                  </div>
                  <div class="resp-col">
                    <div class="textbox-with-btn-left">
                      <input type="text" [attr.disabled]="IsInitialLoad == 1 ? 'true' : null" inputmode="numeric" class="form-control interestcriteriadisable" placeholder="- Max -" maxlength="18" dropSpecialCharacters="false" mask="separator.10.0" thousandSeparator=","
                             [(ngModel)]="interestcriteriaInputModel.askingpricemax" (change)="onlyDecimal($event);" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)">
                      <span class="leftlabel">$</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Cap Rate</label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="margin-bottom-20 row">
                  <div class="resp-col">
                    <div class="textbox-with-btn textbox-with-2character">
                      <input type="text" class="search-field-input form-control interestcriteriadisable" (keypress)="numberOnly($event)" dropSpecialCharacters="false" (change)="onlyDecimal($event);" [attr.disabled]="IsInitialLoad==1?'true':null" placeholder="- Min -" [(ngModel)]="interestcriteriaInputModel.capratemin">
                      <span class="rightlabel">%</span>
                    </div>
                    <div>
                      <p class="redtext" *ngIf="interestcriteriaInputModel.capratemin>100">
                        Cap Rate cannot be greater than 100
                      </p>
                      <p class="redtext" *ngIf="interestcriteriaInputModel.capratemin>100">
                        Cap Rate cannot be less than 0
                      </p>
                    </div>

                    <span class="minusspan">-</span>
                  </div>
                  <div class="resp-col">
                    <div class="textbox-with-btn textbox-with-2character">
                      <input type="text" class="search-field-input form-control interestcriteriadisable" (keypress)="numberOnly($event)" dropSpecialCharacters="false" (change)="onlyDecimal($event);" [attr.disabled]="IsInitialLoad==1?'true':null" placeholder="- Max -" [(ngModel)]="interestcriteriaInputModel.capratemax">
                      <span class="rightlabel">%</span>
                    </div>
                    <div>
                      <p class="redtext" *ngIf="interestcriteriaInputModel.capratemax>100">
                        Cap Rate cannot be greater than 100
                      </p>
                      <p class="redtext" *ngIf="interestcriteriaInputModel.capratemax<0">
                        Cap Rate cannot be less than 0
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Remaining Lease Term </label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="margin-bottom-20 row">
                  <div class="resp-col">
                    <div class="textbox-with-btn-left">
                      <input type="text" class="form-control interestcriteriadisable" [attr.disabled]="IsInitialLoad==1?'true':null" placeholder="- Min -" [(ngModel)]="interestcriteriaInputModel.releasetermmin">
                      <span class="leftlabel"></span>
                    </div>
                    <span class="minusspan">-</span>
                  </div>
                  <div class="resp-col">
                    <div class="textbox-with-btn-left">
                      <input type="text" class="form-control interestcriteriadisable" [attr.disabled]="IsInitialLoad==1?'true':null" placeholder="- Max -" [(ngModel)]="interestcriteriaInputModel.releasetermmax">
                      <span class="leftlabel"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="IsInitialLoad==1">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <label class="form-label">Asking Price</label>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="margin-bottom-20 row">
                <div class="resp-col">
                  <div class="textbox-with-btn-left">
                    <span class="displayvalue whitespacenowrap" *ngIf="interestcriteriaInputModel.askingpricemin!=null||interestcriteriaInputModel.askingpricemin!=null">{{ interestcriteriaInputModel.askingpricemin!=null ? interestcriteriaInputModel.askingpricemax!=null ? (' $ '+ (interestcriteriaInputModel.askingpricemin|number)+' - $ ' +(interestcriteriaInputModel.askingpricemax|number)):('$ ' +(interestcriteriaInputModel.askingpricemin|number)) :interestcriteriaInputModel.askingpricemax!=null ? ('$ '+(interestcriteriaInputModel.askingpricemax|number)): '-' }}</span>
                    <label *ngIf="interestcriteriaInputModel.askingpricemin==null&&interestcriteriaInputModel.askingpricemin==null">
                      <span>-</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <label class="form-label">Cap Rate</label>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="margin-bottom-20 row">
                <div class="resp-col">
                  <div class="textbox-with-btn-left">
                    <span class="displayvalue" *ngIf="interestcriteriaInputModel.capratemax!=null||interestcriteriaInputModel.capratemin!=null">{{ interestcriteriaInputModel.capratemin!=null ? interestcriteriaInputModel.capratemax!=null ? (interestcriteriaInputModel.capratemin+' % - ' +interestcriteriaInputModel.capratemax +' %'):(interestcriteriaInputModel.capratemin+' %') :interestcriteriaInputModel.capratemax!=null ? (interestcriteriaInputModel.capratemax+' % - '): '-' }}</span>
                    <label *ngIf="interestcriteriaInputModel.capratemin==null&&interestcriteriaInputModel.capratemax==null">
                      <span>-</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <label class="form-label">Remaining Lease Term</label>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="margin-bottom-20 row">
                <div class="resp-col">
                  <div class="textbox-with-btn-left">
                    <span class="data" *ngIf="interestcriteriaInputModel.releasetermmax!=null||interestcriteriaInputModel.releasetermmin!=null">{{ interestcriteriaInputModel.releasetermmin!=null ? interestcriteriaInputModel.releasetermmax!=null ? (interestcriteriaInputModel.releasetermmin+' - ' +interestcriteriaInputModel.releasetermmax):(interestcriteriaInputModel.releasetermmin) :interestcriteriaInputModel.releasetermmax!=null ? (interestcriteriaInputModel.releasetermmax): '-' }}</span>
                    <label *ngIf="interestcriteriaInputModel.releasetermmax==null&&interestcriteriaInputModel.releasetermmin==null">
                      <span>-</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox margin-bottom-10">
          <div class="form-group">
            <label class="form-label">Interested Property Type(s)</label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox" *ngIf="IsInitialLoad!=1">
                <label class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="selectAllAssetTypeValue" [attr.disabled]="IsInitialLoad==1?'true':null" (change)="assetsCheckAll($event);">
                  Select All
                  <i></i>
                </label>
                <label class="custom-checkbox" *ngFor="let assets of assetType">
                  <input type="checkbox" [(ngModel)]="assets.selected" [attr.disabled]="IsInitialLoad==1?'true':null" (change)="assetsChecked(assets.id,$event);">
                  {{assets.description}}
                  <i></i>
                </label>
              </div>

              <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="IsInitialLoad==1">
                <span class="be-tag-01" *ngFor="let item of DuplicateAsset; let i = index">{{item}}</span>
                <label *ngIf="DuplicateAsset==null||DuplicateAsset?.length==0">
                  <span>-</span>
                </label>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom-10">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">Subcategory</label>
                <div class="select-dropdown multiselectdesign margin-bottom-30" *ngIf="IsInitialLoad!=1">
                  <mat-form-field>
                    <mat-select placeholder="Select Subcategories"
                                [(ngModel)]="interestcriteriaInputModel.PropertyTypeSubcategoryList"
                                multiple>
                      @if (interestcriteriaInputModel.PropertyTypeSubcategoryList?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ interestcriteriaInputModel.PropertyTypeSubcategoryList?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (subcategory of subCategoriesList; track subcategory) {
                      <mat-option [value]="subcategory.id" class="multi-dropdown-item">{{subcategory.name}}</mat-option>
                      }
                      @if (subCategoriesList.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="IsInitialLoad==1">
            <span class="be-tag-01" *ngFor="let item of interestcriteriaInputModel.SelectedSubcategoryList; let i = index">{{item}}</span>
            <label *ngIf="interestcriteriaInputModel==null||interestcriteriaInputModel.SelectedSubcategoryList==null||interestcriteriaInputModel.SelectedSubcategoryList?.length==0">
              <span>-</span>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox margin-bottom-10">
          <div class="form-group">
            <label class="form-label">Region(s)</label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox  margin-bottom-10" *ngIf="IsInitialLoad!=1">
                <label class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="selectAllgeographyValue" [attr.disabled]="IsInitialLoad==1?'true':null" (change)="geographyCheckAll($event);">
                  Select All
                  <i></i>
                </label>
                <label class="custom-checkbox" *ngFor="let geo of geography">
                  <input type="checkbox" [(ngModel)]="geo.selected" [attr.disabled]="IsInitialLoad==1?'true':null" (change)="geographyChecked(geo.id,$event);">
                  {{geo.description}}
                  <i></i>
                </label>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox" *ngIf="IsInitialLoad==1">
                <span class="be-tag-01" *ngFor="let item of Duplicategeography; let i = index">{{item}}</span>
                <label *ngIf="Duplicategeography==null||Duplicategeography?.length==0">
                  <span>-</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom-10">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">State(s)</label>
                <div class="textbox-date margin-top-10" *ngIf="IsInitialLoad!=1">
                  <tag-input [ngModel]="states" class="taginputclass" (onTextChange)="stateSearch($event)" (onAdd)="onAdd($event,'State')"
                             (onRemove)="onRemove($event,'State')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Search" placeholder="+ States">
                    <tag-input-dropdown [showDropdownIfEmpty]="true"
                                        [autocompleteItems]="statelst">
                    </tag-input-dropdown>
                  </tag-input>
                </div>
              </div>
            </div>
          </div>
          <span class="textbox-date margin-top-10" *ngIf="IsInitialLoad==1">
            <span *ngFor="let t of states" class="tagsdetails">
              {{t.display}}
            </span>
            <label *ngIf="states==null||states?.length==0">
              <span>-</span>
            </label>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox margin-bottom-15">
          <div class="form-group">
            <label class="form-label">Lease Structure</label>
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox  margin-bottom-15" *ngIf="IsInitialLoad!=1">
                <label class="custom-checkbox" *ngFor="let lease of leaseTerm">
                  <input type="checkbox" [(ngModel)]="lease.selected" [attr.disabled]="IsInitialLoad==1?'true':null" (change)="LeaseStructureChecked(lease.id,$event);">
                  {{lease.description}}
                  <i></i>
                </label>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox  margin-bottom-15" *ngIf="IsInitialLoad==1">
                <span class="be-tag-01" *ngFor="let item of Duplicateleaseterm; let i = index">{{item}}</span>
                <label *ngIf="Duplicateleaseterm==null||Duplicateleaseterm?.length==0">
                  <span>-</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12  inline-checkbox margin-bottom-15">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-6">
                <label class="form-label">Target Tenants</label>
                <div class="textbox-date margin-top-10" *ngIf="IsInitialLoad!=1">
                  <tag-input [ngModel]="tenants" class="taginputclass"
                             (onTextChange)="tenantSearch($event)"
                             (onAdd)="onAdd($event, 'Tenant')"
                             (onRemove)="onRemove($event, 'Tenant')"
                             [onlyFromAutocomplete]="true"
                             secondaryPlaceholder="Search"
                             placeholder="+ Tenants">

                    <tag-input-dropdown [showDropdownIfEmpty]="true"
                                        [autocompleteItems]="tenantlst">
                    </tag-input-dropdown>
                  </tag-input>
                </div>
              </div>
            </div>
            <span class="textbox-date margin-top-10" *ngIf="IsInitialLoad==1">
              <span *ngFor="let t of tenants" class="tagsdetails">
                {{t.display}}
              </span>
              <label *ngIf="tenants==null||tenants?.length==0">
                <span>-</span>
              </label>
            </span>
          </div>
          <div></div>
        </div>

      </div>
      <div class="text-right bottom-btn">
        <button type="button" class="btn btn-default btn-lg  margin-bottom-10" (click)="clearFeilds();" *ngIf="IsInitialLoad!=1">Cancel</button>
        <button class="btn btn-success btn-lg  margin-bottom-10" (click)="onsubmit();" *ngIf="IsInitialLoad!=1"> Save</button>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>


